import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type IConversationProps } from "entity/conversation/Conversation/Conversation";

const Conversation = lazyLoadWithRetry(() => import("./Conversation"));

export const RouteConversation = (
    props: Omit<IConversationProps, "entityId" | "builderId" | "entityType">,
) => (
    <RouteRelative
        path={routes.conversation.details}
        render={(routeProps) => {
            return (
                <BTSuspense>
                    <Conversation
                        {...props}
                        {...routeProps}
                        entityId={parseInt(routeProps.match.params.entityId)}
                        builderId={parseInt(routeProps.match.params.builderId)}
                        entityType={parseInt(routeProps.match.params.entityType)}
                        jobId={parseInt(routeProps.match.params.jobId)}
                    />
                </BTSuspense>
            );
        }}
    />
);
